import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { SetChargePointsTariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/set-charge-points-tariff.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useUpdateChargePointTariffContext } from '../../charge-point.context';
import { ChargePointTariffUpdateFormStep1Controller } from '../charge-point-tariff-update-form-step-1/charge-point-tariff-update-form-step-1.controller';

export interface ChargePointTariffUpdateFormControllerProps {
  onError: SubmitErrorHandler<
    Pick<SetChargePointsTariffModel, 'chargePointIds' | 'tariffId'>
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Pick<SetChargePointsTariffModel, 'chargePointIds' | 'tariffId'>
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const ChargePointTariffUpdateFormController = (
  props: ChargePointTariffUpdateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useUpdateChargePointTariffContext();

  return (
    <MultiStepFormProvider<
      Pick<SetChargePointsTariffModel, 'chargePointIds' | 'tariffId'>
    >
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['tariffId'],
          component: <ChargePointTariffUpdateFormStep1Controller />,
        },
      ]}
    />
  );
};
